// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
import {isSustainity} from "@/libs/application";

export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

let logo = require('@/assets/images/logo/chemity_logo.png');
let brandingLogo = require('@/assets/images/logo/chemity_logo_branding.png');
let appName = 'Chemity';
if (isSustainity()) {
  appName = 'Sustainity';
  logo = require('@/assets/images/logo/sustainity_logo.png');
  brandingLogo = require('@/assets/images/logo/sustainity_logo_branding.png');
}

// APP CONFIG
export const $themeConfig = {
  app: {
    brandingLogo,
    appName: appName, // Will update name in navigation menu (Branding)
    privacyPolicyLink: 'https://www.chemity.eu/privacy-policy/',
    googleUserDataPolicy: 'https://www.chemity.eu/google-api-services-user-data-policy/',
    // eslint-disable-next-line global-require
    appLogoDarkImage: logo, // Will update logo in navigation menu (Branding)
    appLogoWhiteImage: logo, // Will update logo in navigation menu (Branding)
    chemitySymbol: logo
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'zoom-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'sticky', // static , sticky , floating, hidden
      backgroundColor: 'primary', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: false,
    enableScrollToTop: true,
  },
}
